import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { ReceitaPrintClient } from "@/client/modules/atendimento/receita/detalhe/receita-print-client";

export const Route = createFileRoute("/app/atendimento/receita/$id")({
  loader: ({ context, params }) =>
    ensurePage(context.queryClient, apiQuery("atendimento", "receitaPage", { id: params.id })),
  head: () => pageHead("Receita"),
  component: PrintPage,
});

function PrintPage() {
  const { id } = Route.useParams();
  const { data } = useApiSuspenseQuery("atendimento", "receitaPage", { id });
  return <ReceitaPrintClient prescription={data} />;
}
